import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import {
  IMembershipExtensionSubServiceResponse,
  IMembershipExtensionSubServiceResponseData,
} from "@/api_framework/api_modals/MembershipExtension";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

// The endpoint is still being finalised, so accept the id/name aliases it may
// ship with and hand the form a single normalised shape.
const normalizeSubService = (subService: Record<string, any>): IMembershipExtensionSubServiceResponseData => ({
  sub_service_id: subService?.sub_service_id ?? subService?.subcategory_id ?? subService?.id,
  sub_service_name: subService?.sub_service_name ?? subService?.subcategory_name ?? subService?.name,
});

export const useMembershipExtensionSubServicesAPI = () => {
  const [subServices, setSubServices] = useState<IMembershipExtensionSubServiceResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_SUB_SERVICES?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMembershipExtensionSubServiceResponse>) => {
          if (res.data.status === true) {
            const normalized = (res?.data?.data ?? [])
              .map((subService) => normalizeSubService(subService))
              .filter((subService) => !!subService?.sub_service_id);
            setSubServices(normalized);
          } else {
            setSubServices([]);
          }
        })
        .catch((e: AxiosError) => {
          setSubServices([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (error) {
      setSubServices([]);
    }
  }, [dispatch, configuration]);

  return { execute, subServices };
};
